import styled from 'styled-components';

const Div = styled.div`
    margin: 0;
    padding: 0;
`;

const FlexDiv = styled(Div)`
    display: flex;
    flex-direction: ${({ column }) => (column ? 'column' : 'row')};
`;

export {
    Div, FlexDiv,
};
